import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { TournamentProvider } from '../../../contexts/TournamentContext';
import { Sheet, SheetContent } from '../../ui/sheet';
import AdminSidebar from './AdminSidebar';
import AdminTopBar from './AdminTopBar';

const AdminLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <TournamentProvider>
      <div className="flex min-h-screen bg-background text-foreground">
        <div className="sticky top-0 hidden h-screen w-64 shrink-0 lg:block">
          <AdminSidebar />
        </div>

        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" className="w-72 p-0 sm:max-w-xs">
            <AdminSidebar onNavigate={() => setMobileOpen(false)} />
          </SheetContent>
        </Sheet>

        <div className="flex min-w-0 flex-1 flex-col">
          <AdminTopBar onMobileOpen={() => setMobileOpen(true)} />

          <main className="flex-1 overflow-x-clip">
            <div className="mx-auto w-full max-w-screen-2xl px-4 sm:px-6 lg:px-10">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </TournamentProvider>
  );
};

export default AdminLayout;
